import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, PropType, ref } from "vue";
import { TirPmInput } from "tir-pm-input";
import { DatepickerTypeEnum } from "../../enums";
import { useDatepickerInput } from "../../composables";
import { DatepickerInputProps } from "../../types";


export default /*#__PURE__*/_defineComponent({
  __name: 'datepicker-input',
  props: {
  /**Выбранная дата */
  modelValue: { type: Date },
  /**Тип инпута (для выбора конфига маски) */
  type: { type: String as PropType<DatepickerTypeEnum>, required: true },
  /**Блокировка */
  isDisabled: { type: Boolean, default: false },
  /**Настройки */
  settings: { type: Object as PropType<DatepickerInputProps>, required: true },
},
  emits: ["update:modelValue", "focus", "enter", "blur"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;





/**Ссылка на инпут */
const $input = ref<InstanceType<typeof TirPmInput>>();

/**Дата */
const date = computed(() => props.modelValue);
/**Установить дату */
const setDate = (date: Date | undefined) => emit("update:modelValue", date);

const {
  maskOptions,
  innerValue,
  placeholder,
  isErrorBorder,
  isValidInnerValue,
  onAccept,
  onComplete,
  onBlur,
} = useDatepickerInput({
  date,
  setDate,
  type: props.type,
});

const onBlurInput = () => {
  onBlur();
  emit("blur", isValidInnerValue.value);
};

__expose({
  $input,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmInput), {
    class: "datepicker-input",
    ref_key: "$input",
    ref: $input,
    "model-value": _unref(innerValue),
    label: __props.settings.label,
    mask: _unref(maskOptions),
    "is-disabled": __props.isDisabled,
    placeholder: _unref(placeholder),
    "is-small-size": __props.settings.isSmall,
    "is-show-hint": __props.settings.isShowHint,
    "is-with-hint": __props.settings.isWithHint,
    "is-with-error": _unref(isErrorBorder) || __props.settings.isWithError,
    "is-with-success": __props.settings.isWithSuccess,
    onCompleteMask: _unref(onComplete),
    onAcceptMask: _unref(onAccept),
    onBlur: onBlurInput,
    onFocus: _cache[0] || (_cache[0] = ($event: any) => (emit('focus'))),
    onEnter: _cache[1] || (_cache[1] = ($event: any) => (emit('enter', _unref(isValidInnerValue))))
  }, {
    rightInputAddons: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    hintMessage: _withCtx(() => [
      _renderSlot(_ctx.$slots, "hintMessage")
    ]),
    _: 3
  }, 8, ["model-value", "label", "mask", "is-disabled", "placeholder", "is-small-size", "is-show-hint", "is-with-hint", "is-with-error", "is-with-success", "onCompleteMask", "onAcceptMask"]))
}
}

})